import Typography from '~/components/Typography';

interface Props {
  title: string;
  description?: string;
  fontFamily: string;
  accentColor: string;
  textColor: string;
  fontSize: string;
  isNewWebBuilder?: boolean;
}

const SectionHeading = ({
  title,
  description,
  fontFamily,
  accentColor,
  textColor,
  fontSize,
  isNewWebBuilder = false,
}: Props) => {
  return (
    <div className="flex flex-col space-y-0">
      <Typography
        as="h4"
        size={isNewWebBuilder ? (fontSize as any) : 'xl'}
        fontFamily={fontFamily}
        fontFamilyv2={isNewWebBuilder ? fontFamily : undefined}
        color={accentColor}
        weight="bold"
      >
        {title}
      </Typography>
      {description && (
        <Typography
          as="p"
          size="lg"
          fontFamily={fontFamily}
          fontFamilyv2={isNewWebBuilder ? fontFamily : undefined}
          color={textColor}
          weight="regular"
        >
          {description}
        </Typography>
      )}
    </div>
  );
};

export default SectionHeading;
